import React, { useEffect, useState } from "react"

import BasicButton from "./BasicButton"

/**
 * @typedef Props
 * @property {number} currentPage
 * @property {number} chunk
 * @property {number} allItemsInt
 * @property {string} className
 * @property {boolean} showPages
 * @property {(page: number) => void} callback
 */

/**
 * @param {Props} props 
 */
export default function Pagination(props) {
    const [page, setPage] = useState(props.currentPage || 0)
    const chunk = props.chunk || 1
    let newPageStart = page + chunk

    useEffect(() => {
        setPage(props.currentPage)
    }, [props.currentPage])

    const pageButtons = []
    if(props.showPages){
        let p = 1
        for(let i = 0; props.allItemsInt > i; i += chunk){
            pageButtons.push(<BasicButton
                key={i}
                label={p}
                selected={i === page}
                action={()=> {
                    setPage(i)
                    props.callback(i)
                }}
            />)
            p++
        }
    }

    return <div className={"pagination-set " + (props.className || "btn-set")}>
        {!props.disableLoop && <BasicButton
            btnClass={props.btnClass || "2nd"}
            action={()=> {
                newPageStart = page - chunk
                if (newPageStart < 0){
                    newPageStart = 0
                    if(props.showPages){
                        //loop to end if showing page numbers
                        let res = props.allItemsInt % chunk
                        newPageStart = (((props.allItemsInt - res) / chunk) * chunk)
                        if(res === 0) newPageStart = newPageStart - chunk
                    }
                }
                setPage(newPageStart)
                props.callback(newPageStart)
            }}
            disabled={page <= 0 && (!props.showPages || props.disableLoop)}
            icon={"chevron-left"}
        />}
        {pageButtons}
        {!props.disableLoop && <BasicButton
            btnClass={props.btnClass || "2nd"}
            action={()=> {
                //loop to start if showing page numbers
                if (newPageStart >= props.allItemsInt && props.showPages) newPageStart = 0
                setPage(newPageStart)
                props.callback(newPageStart)
            }}
            disabled={page + chunk >= props.allItemsInt && (!props.showPages || props.disableLoop)}
            icon={"chevron-right"}
        />}
    </div>
}